import type { WorkSchedule } from '@trinnvis/dabih-api-client';
import { WorkScheduleRestPeriodEnum } from '@trinnvis/dabih-api-client';
import { defaultWorkStartTime } from './default-work-start-time';
import { defaultWorkEndTime } from './default-work-end-time';
import { defaultWorkWeek } from './default-work-week';

export const defaultWorkSchedule: WorkSchedule = {
  start: '',
  holidaysAreTimeOff: true,
  restPeriod: WorkScheduleRestPeriodEnum.WithoutPay,
  workHoursDefinedPerDay: false,
  workDayStartTime: defaultWorkStartTime,
  workDayEndTime: defaultWorkEndTime,
  workWeeks: [defaultWorkWeek],
};
